import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListarClientesComponent } from './listar-clientes/listar-clientes.component';
import { ClienteFormComponent } from './cliente-form/cliente-form.component';

// Form unificado: la MISMA pantalla crea y edita. `CrearClienteWizardComponent`,
// `ProvisionadorComponent` y `CrearEditarClienteComponent` siguen en el módulo pero ya no
// tienen ruta: quedan como referencia hasta que se decida borrarlos.
const routes: Routes = [
  { path: '', component: ListarClientesComponent },
  { path: 'crear', component: ClienteFormComponent, canActivate: [] },
  { path: 'editar/:id', component: ClienteFormComponent, canActivate: [] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientesRoutingModule {}
